import * as Yup from 'yup';
import { Dispatch, SetStateAction } from 'react'
import {Formik, Form, Field} from 'formik'
import {FileUpload, FormActions, handleErrors} from '@/components/form'
import {SupplierOperation} from '../../core/_models'
import {uploadVouchers} from '../../core/_requests'

const validationSchema = Yup.object().shape({
  vouchers: Yup.mixed().required('A csv file is required')
})

type Props = {
  order: SupplierOperation
  setOrder: Dispatch<SetStateAction<SupplierOperation | undefined>>
}

const UploadVouchers: React.FC<Props> = ({order, setOrder}) => {
  const initialValues  = {
    vouchers: null,
    operationId: order._id
  }

  return (
    <div className="text-center">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, {setErrors}) => {
          try {
            if (values.vouchers) {
              const formData = new FormData()
              formData.append('vouchers', values.vouchers)
              formData.append('operationId', values.operationId as string)
              setOrder(await uploadVouchers(formData))
            }
          } catch (e: any) {
            handleErrors(e, setErrors)
          }
        }}
      >
        {({ values }) => (
          <Form>
            <Field
              component={FileUpload}
              name="vouchers"
              accept="text/csv"
              required={true}
              label='Import CSV file containing vouchers'
            />
            <Field
              name="operationId"
              type="hidden"
            />
            <Field
              component={FormActions}
              confirmBtnLabel='Upload'
              noDiscardBtn={true}
              padding="pt-0"
            />
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default UploadVouchers
